module.exports = JBrowseExports["react-dom"];